import { render, staticRenderFns } from "./UcContractServiceFees.yaml?vue&type=template&id=1c3c060d&component"
import script from "./UcContractServiceFees.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractServiceFees.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports